export default __webpack_public_path__ + "static/sagePoppy-8fc3f12543bda576b3e54ce89b7f906a.webp";